import Main from "../../Layout/Main";
import SliderBanner from '../../Components/Home/SliderBanner'
import AboutSection from "../../Components/Home/AboutSection";
import FunFact from "../../Components/Home/FunFact";
import Speaker from "../../Components/Home/Speaker";
import Schduel from "../../Components/Home/Schduel";
import Pricing from "../../Components/Home/Pricing";

const Home = () => {
    return (
        <Main>
            <SliderBanner />
            <AboutSection/>
                <FunFact/>
                <Speaker/>
                <Schduel/>
                <Pricing/>
        </Main>
    )
}

export default Home